// extracted by mini-css-extract-plugin
export default {"rankedDateWrapper":"rankedDateWrapper__ZDY4M","btn":"btn__OTc2Y"};